// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyPlaceholder_container__26OeU","skeleton-anim":"EmptyPlaceholder_skeleton-anim__1k_eS","fadeIn1":"EmptyPlaceholder_fadeIn1__-DqKc"};